export type OptionObjProps = Record<string, string[]>;

export const Options: OptionObjProps = {
  quickstart_path: [
    "Notecard and Notecarrier A",
    "Notecard and Notecarrier F",
    "Notecard and Notecarrier B",
    "Notecard and Notecarrier Pi",
    "Notecard Simulator",
    "Notecard and SparkFun Qwiic Cellular",
    "Notecard and SparkFun MicroMod Cellular Function Board",
  ],
  notecarrier: [
    "Notecarrier A",
    "Notecarrier AA",
    "Notecarrier AE",
    "Notecarrier AL",
    "Notecarrier AF",

    // The sensor tutorial requires an unversioned listing
    "Notecarrier F",
    "Notecarrier Pi",

    // Versioned listings for the datasheets
    "Notecarrier F v1.0",
    "Notecarrier F v1.3",
    "Notecarrier B v1.0",
    "Notecarrier B v2.1",
    "Notecarrier B v3.1",
    "Notecarrier Pi v1.0",
    "Notecarrier Pi v2.0",
    "Notecarrier R v1.0",
    "SparkFun MicroMod Cellular Function Board",
    "Sparkfun Qwiic Cellular",
  ],
  notecard: [
    "NOTE-WBGLW",
    "NOTE-NBGLW",
    "NOTE-NBGL-500",
    "NOTE-WBNAW",
    "NOTE-NBNAW",
    "NOTE-WBNA-500",
    "NOTE-NBNA-500",
    "NOTE-WBEXW",
    "NOTE-WBEX-500",
    "NOTE-WIFI",
    "NOTE-ESP",
    "NOTE-LORA",
  ],
  board: [
    "Arduino Nano 33 BLE Sense",
    "Artemis Thing Plus",
    "Adafruit HUZZAH32",
    "Adafruit Feather M4 Express",
    "Blues Swan",
    "Raspberry Pi",
    "SparkFun MicroMod STM32 Processor",
    "STM32 Discovery",
    "STM32 Nucleo",
  ],
  language: [
    "CircuitPython",
    "C/C++ (Arduino/Wiring)",
    "C/C++ (STM32Cube)",
    "Python",
    "JavaScript",
    "STMDuino",
  ],
  service: [
    "ThingSpeak",
    "Azure IoT Central",
    "General HTTP/HTTPS",
    "Snowflake",
    "Initial State",
    "IoT Central",
    "InfluxDB",
    "AWS IoT Analytics",
    "Ubidots",
    "Google Cloud Platform",
    "Datacake",
    "MQTT",
    "ThingWorx",
  ],
  swan_datasheet_version: ["Swan v1.5", "Swan v1.7", "Swan v3.0"],
  airnote_datasheet_version: ["Airnote v1.0", "Airnote v2.0"],
};

// TODO: pass this down in [[...slugs]].tsx when it gets refactored
//       and cleanup DocConfig in config/nav.ts
export type DocMeta = {
  allPaths: string[];
  defaultVals: string[];
  description: string;
  navTitle: string;
  props: string[];
  publicationStatus: string;
  keywords: string[];
};
